import { connect } from "react-redux";
import { getItemCount, hasFacets } from "../../state/modules/search";
import { getError } from "../../state/modules/error";
import { getIsNewSearch } from "../../state/modules/search/selectors";
import ProductListingPage from "../../components/ProductListingPage";

export function mapStateToProps(state) {
  return {
    itemCount: getItemCount(state),
    error: getError(state),
    featureToggles: state.featureToggles,
    isNewSearch: getIsNewSearch(state),
    hasFacets: hasFacets(state),
    isLoading: state.search.isLoading
  };
}

export default connect(mapStateToProps)(ProductListingPage);
